package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun TinyHutMetadata() {
    SpellMetadata(
        spellIndex = "tiny-hut",
        castingTime = "1 minute",
        range = "Self",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A small crystal bead.",
        duration = "8 hours",
        damageBase = null,
        damageScaling = null,
        savingThrow = null,
        aoe = "10-ft Sphere",
        concentration = false
    )
}
